/**
 * DB 数据转换。 将CuePoint.msg 文件内容转换成为关系型数据
 *
 * @export
 * @class DBDataParser
 */
export default class DBDataParser {
  constructor() {}

  static parse(data) {
    let result = [];
    data.forEach(item => {
      // 旧数据没有content2
      let str = item['content2'];
      if (!item['content2']) {
        str = item['content'];
      }
      const o = JSON.parse(str);
      let obj = {
        time: item.created_at,
        content: str, // string
        uid: +o.uniqueID,
        flipOver: +o.flipOver,
        cid: o.cid,
        hash: o.hash,
        currentPage: o.currentPage
      };

      result.push(obj);
    });
    return result;
  }
}
